import React from 'react';
import { Card, CardBody } from '@chakra-ui/react';

function CardContainer({ selectable, productDetail, isHovering, onSelectProduct, children }) {
  return (
    <Card
      _hover={{
        zIndex: 2,
      }}
      transition="transform .25s, height .25s"
      position="relative"
      boxShadow="none"
      textDecoration="none"
      {...(selectable && {
        onClick: () => onSelectProduct(productDetail),
      })}
    >
      <CardBody p={0} borderRadius="12px" overflow="hidden">
        {children}
      </CardBody>
    </Card>
  );
}

export default CardContainer;
